export const COURT_CASES_TABLE_ARIA_LABEL = 'Судові справи';
export const COURT_CASES_TABLE_MIN_WIDTH = 1460;
export const COURT_CASES_DATE_COLUMN_INDEXES = [5] as const;
export const COURT_CASES_TABLE_HEADERS = [
  'Найменування іншої сторони спору',
  'Найменування Позичальника',
  'Статус Позичальника у судовій справі',
  'Предмет спору',
  'Сума позову, тис. од.',
  'Дата подання позову',
  'Коментар про поточний стан справи',
] as const;
export const COURT_CASES_TABLE_COLUMN_WIDTHS = [
  '14%',
  '19%',
  '11%',
  '18%',
  '12%',
  '9%',
  '17%',
] as const;
